<template>
  <woot-modal :show="show" :on-close="handleClose">
    <woot-modal-header
      :header-title="isEditing ? $t('BUSINESS_DATA.AI_SAMPLE_SENTENCES.EDIT') : $t('BUSINESS_DATA.AI_SAMPLE_SENTENCES.ADD_NEW')"
    />
    <form class="flex flex-col modal-content" @submit.prevent="handleSubmit">
      <div class="space-y-5">
        <div class="space-y-2">
          <woot-input
            v-model="form.title"
            :label="$t('BUSINESS_DATA.AI_SAMPLE_SENTENCES.TITLE_LABEL')"
            :required="true"
            :placeholder="$t('BUSINESS_DATA.AI_SAMPLE_SENTENCES.TITLE_PLACEHOLDER')"
            :error="v$.form.title.$error ? $t('BUSINESS_DATA.AI_SAMPLE_SENTENCES.TITLE_ERROR') : ''"
            :class="{ error: v$.form.title.$error }"
            type="text"
            maxlength="150"
            @blur="v$.form.title.$touch"
          />
          <div v-if="!v$.form.title.$error" class="flex justify-end text-xs">
            <span :class="form.title.length > 180 ? 'text-red-500 dark:text-red-400' : 'text-slate-500 dark:text-slate-400'">
              {{ form.title.length }}/150
            </span>
          </div>
        </div>

        <div class="space-y-2">
          <FormLabel
            :label="$t('BUSINESS_DATA.AI_SAMPLE_SENTENCES.CONTENT_LABEL')"
            :required="true"
            :has-error="v$.form.description.$error"
          />
          <TextArea
            v-model="form.description"
            name="ai-sample-description"
            :placeholder="$t('BUSINESS_DATA.AI_SAMPLE_SENTENCES.CONTENT_PLACEHOLDER')"
            :max-length="2000"
            show-character-count
            :message="v$.form.description.$error ? $t('BUSINESS_DATA.AI_SAMPLE_SENTENCES.CONTENT_ERROR') : ''"
            :message-type="v$.form.description.$error ? 'error' : 'info'"
            auto-height
            :resize="true"
            :min-height="'100px'"
            :disabled="loading"
            @blur="v$.form.description.$touch"
          />
        </div>
      </div>

      <div class="flex justify-center gap-3 pt-4">
        <woot-button type="button" variant="smooth" color-scheme="ghost" @click="handleClose">
          {{ $t('COMMON.CANCEL') }}
        </woot-button>

        <woot-button
          type="submit"
          variant="smooth"
          color-scheme="success"
          :is-loading="loading"
          :disabled="!isValid || loading"
        >
          {{ isEditing ? $t('COMMON.UPDATE') : $t('COMMON.CREATE') }}
        </woot-button>
      </div>
    </form>
  </woot-modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, maxLength } from '@vuelidate/validators';
import FormLabel from 'dashboard/components/widgets/forms/FormLabel.vue';
import TextArea from 'dashboard/components-next/textarea/TextArea.vue';
export default {
  name: 'AiSampleSentenceModal',
  setup() {
    return { v$: useVuelidate() };
  },
  components: { FormLabel, TextArea },
  props: {
    show: { type: Boolean, default: false },
    sampleSentence: { type: Object, default: null },
    loading: { type: Boolean, default: false }
  },
  emits: ['close', 'save'],
  data() {
    return {
      form: {
        title: '',
        description: ''
      }
    }
  },
  computed: {
    isEditing() {
      return !!this.sampleSentence
    },
    isValid() {
      return this.form.title.trim().length > 0 && this.form.description.trim().length > 0
    }
  },
  validations: {
    form: {
      title: { required, maxLength: maxLength(200) },
      description: { required, maxLength: maxLength(2000) },
    },
  },
  watch: {
    sampleSentence: {
      immediate: true,
      handler(sample) {
        if (sample) {
          this.form = {
            title: sample.title || '',
            description: sample.description || ''
          }
        } else {
          this.resetForm()
        }
      }
    },
    show(newValue) {
      if (!newValue) {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.form = { title: '', description: '' }
      if (this.v$ && typeof this.v$.$reset === 'function') {
        this.v$.$reset()
      }
    },
    handleClose() {
      if (this.v$ && typeof this.v$.$reset === 'function') {
        this.v$.$reset();
      }
      this.$emit('close')
    },
    handleSubmit() {
      this.v$.$touch();
      if (this.v$.$invalid || !this.isValid || this.loading) {
        return
      }
      this.$emit('save', { ...this.form })
    }
  }
}
</script>
